import { Link } from "react-router-dom";

const Two = () => {
  return (
    <>
      <div className="container-fluid jumbotron jumbotron-image py-5">
        <div className="container">
          <h1 className="display-3 fw-bold text-white">Simpozion #2</h1>
        </div>
      </div>
      <div className="container">
        <nav aria-label="breadcrumb" className="mb-3 mt-4 ms-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Acasă</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/evenimente">Evenimente</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Simpozion #2
            </li>
          </ol>
        </nav>
        <div className="container history">
          <div className="row">
            <div className="col-lg-12 bg-light rounded p-4">
              <h2 className=" pb-1 mb-4 fst-italic">Invitație</h2>
              <p>
                Asociația Oncohem Cluj-Napoca organizează sub egida Institutului
                Oncologic Ion Chiricuta Cluj-Napoca simpozionul intitulat{" "}
                <b>
                  “Workshop on hemophilia and rare bleeding disorders”-
                  ‘Workshop: hemofilia si sindroame hemoragipare rare”
                </b>
                , desfășurat în data de 16.11.2024 la Cluj-Napoca, la Hotel
                Golden Tulip, sala Colosseum.
              </p>
              <p>
                Tematica cuprinde anomaliile congenitale ale hemostazei, fiind
                invitați lectori cu experiență, atât din străinatate, cât și din
                România.
              </p>
              <p>
                Pe lângă prezentările teoretice, simpozionul va cuprinde și un
                workshop practic despre abordarea complicațiilor
                musculoscheletale ale pacienților hemofilici, în care
                participanții vor avea ocazia să învețe atât tehnici de
                diagnosticare cât și metode de terapie de recuperare.
              </p>
              <p>
                Manifestarea se adresează medicilor hematologi, pediatri si de
                laborator.
              </p>
              <p>
                Participarea este gratuită, cei interesați trebuie să se înscrie
                folosind formularul din link-ul atașat.
              </p>
              <p className="mb-1">
                Formular înscriere:{" "}
                <a href="https://docs.google.com/forms/d/e/1FAIpQLScPJ8-0UnMuC5H9UdkIozBZkEfgLvTrkjRG3HSOm2hAaweQ1Q/viewform?pli=1">
                  Link
                </a>
              </p>
              <p className="mb-1">
                Pentru programul detaliat accesați documentul:{" "}
                <a href="https://docs.google.com/document/d/14erS8rI0o6oqbfjJnnb0w2GFZ8cGVEFE714zZomAD_U/edit?usp=sharing">
                  Link
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Two;
